export default "__VITE_ASSET__zVnMl5t8__"